export enum NodeEndPoint {
  generate_project_material_list = '/take-home-project/generate-material-list',
  generate_project_ideas = '/take-home-project/generate-project-idea',
  generate_rubric_template = '/take-home-project/generate-rubric-template',
  generate_feedback = '/take-home-project/project-feedback',
  generate_assessment_feedback = '/model-assistant-route/generate-assessment-feedback',
}
